/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
//import FormControlLabel from "@material-ui/core/FormControlLabel";
// material ui icons
import MailOutline from "@material-ui/icons/MailOutline";
import Slider from "nouislider";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import SweetAlert from "react-bootstrap-sweetalert";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";
import Datetime from "react-datetime";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "../../utils/axiosInstance";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";
// style for this view
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
import reactDom from "react-dom";
import RichTextEditor from "react-rte";
import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import { CircularProgress } from "@material-ui/core";
//const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
const useStyleData = makeStyles(stylesData);

const useStyles = makeStyles(styles);

export default function Donations() {
  let fileInput = React.createRef();

  const [formValues, setFormValues] = React.useState({
    image: "",
    heading: "",
    description: "",
  });
  const [file, setFile] = React.useState(null);
  const [avatar, setAvatar] = React.useState(true);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [alert, setAlert] = React.useState(null);
  const [imageName, setImageName] = React.useState("");
  const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
    avatar ? defaultAvatar : defaultImage
  );
  const [editorBody, setEditorBody] = React.useState(RichTextEditor.createEmptyValue());

  const handleEditorChange = (newValue) => {
    setEditorBody(newValue);
    setFormValues({
      ...formValues,
      "description": newValue.toString("html"),
    });

  };
  const handleImageChange = (e) => {
    e.preventDefault();
    let reader = new FileReader();
    let file = e.target.files[0];
    setImageName("");
    setSelectedFile(e.target.files[0]);
    reader.onloadend = () => {
      setAvatar(true);
      setFile(file);
      setImagePreviewUrl(reader.result);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
    console.log(file, imagePreviewUrl)
  };

  const handleChange = (e) => {
    setFormValues({
      ...formValues,
      [e.target.id]: e.target.value,
    });
    console.log(formValues);
  };

  React.useEffect(() => {
    setImageName("");
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        await axios
          .get(
            `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/donation`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Access-Control-Allow-Origin": "*",
              },
            }
          )
          .then((res) => {
            const data = res.data.data;
            setFormValues({
              heading: data[0].heading,
              description: data[0].description,
            });
            setImageName(data[0].image);
            setEditorBody(RichTextEditor.createValueFromString(data[0].description, 'html'));
            //setEditorBody(.toString('html')))
            setImagePreviewUrl(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/uploads/` + data[0].image)
          });
      } catch (error) {
        console.error(error.message);
        if (error?.response?.data?.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleRemove = () => {
    setFile(null);
    //setAvatar(false);
    // setImageurl(null);
    setImagePreviewUrl(defaultAvatar);
    fileInput.current.value = null;
  };

  const hideAlert = () => {
    setAlert(null);
    window.location.assign("/admin/dashboard");
  };



  const handleSubmitForm = async () => {
    const token = localStorage.getItem("token");
    const formData = new FormData();

    for (const key in formValues) {
      formData.append(key, formValues[key]);
    }
    if (imageName === "undefined" || imageName === "")
      formData.append("donationImage", selectedFile);
    else {
      formData.append("donationImage", imageName);
    }
    axios.put(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/donation`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        }
      }

    ).then((res) => {
      setAlert(
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {res?.data?.message}
            </span>
          }
          onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      );
      //alert("About us Added !!");
    })
      .catch((error) => {
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title={
            <span
              style={{
                fontSize: "14px",
                fontWeight: "bold",
              }}
            >
              {error?.response?.data?.message}
            </span>
          }
         onConfirm={() => setAlert(null)}
          onCancel={() => setAlert(null)}
          titleCssClass={classesSweetAlert.cardTitle}
          confirmBtnCssClass={
            classesSweetAlert.button + " " + classesSweetAlert.success
          }
        />
      })
  }
  const classes = useStyles();
  const classesSweetAlert = useStyleData();
  return (
    <div>

      {!loading ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color="rose" icon>
                <CardIcon color="rose">
                  <MailOutline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Donations</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    <GridItem xs={12} sm={4} md={12}>
                      <legend>Image</legend>
                      <ImageUpload
                        avatar
                        fileValue={file}
                        handleRemove={handleRemove}
                        imagePreviewUrlValue={imagePreviewUrl}
                        handleImageChange={handleImageChange}
                        addButtonProps={{
                          color: "rose",
                          round: true,
                        }}
                        changeButtonProps={{
                          color: "rose",
                          round: true,
                        }}
                        removeButtonProps={{
                          color: "danger",
                          round: true,
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={3}>
                      <CustomInput
                        labelText="Heading"
                        id="heading"
                        handleChange={handleChange}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          type: "text",
                          value: formValues?.heading
                        }}
                      />
                    </GridItem>
                    <GridItem xs={12}>
                      <RichTextEditor
                        value={editorBody}
                        onChange={handleEditorChange}
                        style={{ height: "300px" }}
                      />
                    </GridItem>
                  </GridContainer>

                  <Button
                    color="rose"
                    className={classes.registerButton}
                    onClick={handleSubmitForm}
                  >
                    Save
                  </Button>
                </form>
              </CardBody>
            </Card>
          </GridItem>
          {alert}
        </GridContainer>

      ) : (<div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </div>)}
    </div>
  );
}
